import React from "react";
import Our from "./Our/Our";
import Login from "./Login/Login";

const Account = () => {
  return (
    <>
      <Our />
      <Login />
    </>
  );
};

export default Account;
